function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["loading", "title", "description"],
    _excluded2 = ["totalCount"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// @ts-nocheck
import h from "@macrostrat/hyper";
import update from "immutability-helper";
import { useReducer, useEffect, useRef, useCallback } from "react";
import { Spinner, NonIdealState } from "@blueprintjs/core";
import { useInView } from "react-intersection-observer";
import { useAPIActions } from "./api";
import { JSONView } from "./util/json-view";
import { IndexingProvider } from "./api/indexing";

function infiniteScrollReducer(state, action) {
  var _action$params$page;

  switch (action.type) {
    case "update-state":
      return update(state, action.spec);

    case "load-page":
      action.callback(action);
      return update(state, {
        // @ts-ignore
        isLoadingPage: {
          $set: (_action$params$page = action.params.page) !== null && _action$params$page !== void 0 ? _action$params$page : 0
        }
      });
  }
}

function InfiniteScroll(props) {
  var hasMore = props.hasMore,
      children = props.children,
      className = props.className,
      loadMore = props.loadMore;

  var _useInView = useInView({
    rootMargin: "0px 0px -100px 0px"
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  useEffect(function () {
    if (!hasMore || !inView) return;
    loadMore();
  }, [inView, hasMore]);
  return h("div.infinite-scroll-container", {
    className: className
  }, [children, //h.if(state.isLoadingPage != null)(placeholder),
  h("div.bottom-marker", {
    ref: ref
  })]);
}

var Placeholder = function Placeholder(props) {
  var loading = props.loading,
      _props$title = props.title,
      title = _props$title === void 0 ? "No results yet" : _props$title,
      _props$description = props.description,
      description = _props$description === void 0 ? null : _props$description,
      rest = _objectWithoutProperties(props, _excluded);

  return h("div.placeholder", [h(NonIdealState, _objectSpread({
    icon: "search-template",
    className: "placeholder-inner",
    title: title,
    description: description
  }, rest))]);
};

var LoadingPlaceholder = function LoadingPlaceholder(props) {
  var _props$perPage = props.perPage,
      perPage = _props$perPage === void 0 ? 10 : _props$perPage,
      _props$loadedCount = props.loadedCount,
      loadedCount = _props$loadedCount === void 0 ? 0 : _props$loadedCount,
      _props$itemName = props.itemName,
      itemName = _props$itemName === void 0 ? "results" : _props$itemName;
  var _props$totalCount = props.totalCount,
      totalCount = _props$totalCount === void 0 ? 0 : _props$totalCount;
  var description = null;

  if (totalCount != null) {
    var loadedPages = Math.ceil(loadedCount / perPage);
    var totalPages = Math.ceil(totalCount / perPage);
    description = "Page ".concat(loadedPages, " of ").concat(totalPages);
  }

  return h(Placeholder, {
    icon: h(Spinner),
    title: "Loading " + itemName,
    description: description
  });
};

function EmptyPlaceholder() {
  return h(Placeholder, {
    icon: "inbox",
    title: "No results"
  });
}

function FinishedPlaceholder(_ref) {
  var totalCount = _ref.totalCount,
      rest = _objectWithoutProperties(_ref, _excluded2);

  var description = totalCount != null ? "".concat(totalCount, " total items") : null;
  return h(Placeholder, _objectSpread({
    icon: null,
    title: "No more results",
    description: description
  }, rest));
}

function InfiniteScrollView(props) {
  var _props$totalCount2;

  /*
  A container for cursor-based pagination. This is built for
  the GeoDeepDive API right now, but it can likely be generalized
  for other uses.
  */
  var route = props.route,
      params = props.params,
      opts = props.opts,
      placeholder = props.placeholder,
      className = props.className,
      _props$itemComponent = props.itemComponent,
      itemComponent = _props$itemComponent === void 0 ? JSONView : _props$itemComponent,
      _props$loadingPlaceho = props.loadingPlaceholder,
      loadingPlaceholder = _props$loadingPlaceho === void 0 ? LoadingPlaceholder : _props$loadingPlaceho,
      _props$emptyPlacehold = props.emptyPlaceholder,
      emptyPlaceholder = _props$emptyPlacehold === void 0 ? EmptyPlaceholder : _props$emptyPlacehold,
      _props$finishedPlaceh = props.finishedPlaceholder,
      finishedPlaceholder = _props$finishedPlaceh === void 0 ? FinishedPlaceholder : _props$finishedPlaceh,
      _props$resultsCompone = props.resultsComponent,
      resultsComponent = _props$resultsCompone === void 0 ? "div.results" : _props$resultsCompone,
      _props$perPage2 = props.perPage,
      perPage = _props$perPage2 === void 0 ? 10 : _props$perPage2,
      _props$startPage = props.startPage,
      startPage = _props$startPage === void 0 ? 0 : _props$startPage;

  var _useAPIActions = useAPIActions(),
      get = _useAPIActions.get;

  var getCount = props.getCount,
      getNextParams = props.getNextParams,
      getItems = props.getItems,
      hasMore = props.hasMore;
  var initialState = {
    items: [],
    scrollParams: params,
    count: null,
    error: null,
    hasMore: true,
    isLoadingPage: null,
    pageIndex: startPage
  };
  var pageOffset = 0;

  var _useReducer = useReducer(infiniteScrollReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var loadPage = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(action) {
      var res, itemVals, ival, nextLength, count, p1, hasNextParams;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return get(route, action.params, opts);

            case 2:
              res = _context.sent;
              console.log("Loaded page with params", action.params);
              itemVals = getItems(res);
              ival = {
                $push: itemVals
              };
              nextLength = state.items.length + itemVals.length;
              count = getCount(res);
              console.log(state.items); // if (state.isLoadingPage == null) {
              //   // We have externally cancelled this request (by e.g. moving to a new results set)
              //   console.log("Loading cancelled")
              //   return
              // }

              p1 = getNextParams(res, params);
              hasNextParams = p1 != null;
              console.log("Next page parameters", p1);
              action.dispatch({
                type: "update-state",
                spec: {
                  items: ival,
                  // @ts-ignore
                  scrollParams: {
                    $set: p1
                  },
                  pageIndex: {
                    $set: state.pageIndex + 1
                  },
                  count: {
                    $set: count
                  },
                  hasMore: {
                    $set: hasMore(res) && itemVals.length > 0 && hasNextParams
                  },
                  isLoadingPage: {
                    $set: null
                  }
                }
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [state.items, route, params, opts]);
  var loadMore = useCallback(function () {
    dispatch({
      type: "load-page",
      params: state.scrollParams,
      dispatch: dispatch,
      // @ts-ignore
      callback: loadPage
    });
  }, [state.scrollParams, loadPage, route, params, opts]);
  var isInitialRender = useRef(true);
  var loadInitialData = useCallback(function () {
    // Don't run on initial render
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    console.log("Resetting to initial data");
    /*
    Get the initial dataset
    */
    // const success = await get(route, params, opts);
    // parseResponse(success, true)
    //if (state.items.length == 0 && state.isLoadingPage == null) return

    dispatch({
      type: "update-state",
      spec: {
        $set: initialState
      }
    }); //await loadNext(0)
  }, [isInitialRender, route, params, opts]);
  useEffect(loadInitialData, [props.route, props.params]);
  if (state == null) return null; //useAsyncEffect(getInitialData, [route, params]);
  //const showLoader = state.isLoadingPage != null && state.items.length > 0

  var data = state.items;
  var isLoading = state.isLoadingPage != null;
  var isEmpty = data.length == 0 && !isLoading;
  var isFinished = !state.hasMore && !isLoading;
  var totalCount = (_props$totalCount2 = props.totalCount) !== null && _props$totalCount2 !== void 0 ? _props$totalCount2 : state.count;
  return h(InfiniteScroll, {
    pageStart: -1,
    loadMore: loadMore,
    hasMore: state.hasMore && state.isLoadingPage == null,
    loader: placeholder,
    useWindow: true,
    className: className
  }, [h["if"](isEmpty)(emptyPlaceholder), h["if"](!isEmpty)(IndexingProvider, {
    totalCount: totalCount,
    indexOffset: 0
  }, [h(resultsComponent, {
    data: data
  }, data.map(function (d, i) {
    return h(itemComponent, {
      key: i,
      data: d,
      index: i
    });
  })), // @ts-ignore
  h["if"](isLoading)(loadingPlaceholder, {
    totalCount: totalCount,
    scrollParams: state.scrollParams,
    pageIndex: state.pageIndex,
    loadedCount: data.length,
    perPage: perPage
  }), // @ts-ignore
  h["if"](isFinished)(finishedPlaceholder, {
    totalCount: totalCount
  })])]);
}

InfiniteScrollView.defaultProps = {
  hasMore: function hasMore(a, b) {
    return true;
  },
  getItems: function getItems(d) {
    return d;
  },
  getCount: function getCount(d) {
    return null;
  },
  getNextParams: function getNextParams(response, params) {
    var _params$page;

    var lastPage = (_params$page = params.page) !== null && _params$page !== void 0 ? _params$page : 0;
    return _objectSpread(_objectSpread({}, params), {}, {
      page: lastPage + 1
    });
  },
  placeholder: h(Spinner)
};
export { InfiniteScrollView };